"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOBILE_STEPPER = void 0;
exports.MOBILE_STEPPER = {
    styleOverrides: {
        root: {
            fontFamily: 'Roboto',
            fontSize: '14px',
        },
        dot: {
            height: '12px',
            width: '12px',
        },
        dots: {
            gap: '6px',
        },
    },
};
